// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__L0i8O","subheader":"ReorderModal_subheader__2OZwd","listWrap":"ReorderModal_listWrap__2gvsJ"};